<template>
  <div>
    <ul class="pagination">
      <li @click.prevent="goToPage(pagination.currentPage - 1)">
        <a><i class="fas fa-angle-left"></i></a>
      </li>
      <li v-for="(page, index) in pages" :key="getKey(page, index)">
        <a href="#" @click.prevent="goToPage(page)" v-if="page !== '...'">{{
          page
        }}</a>
        <a v-else>{{ page }}</a>
      </li>
      <li @click.prevent="goToPage(pagination.currentPage + 1)">
        <a><i class="fas fa-angle-right"></i></a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "PaginationComponent",
  props: {
    pagination: {
      required: false,
      default: () => {},
    },
  },
  computed: {
    pages() {
      const pages = [];
      const { currentPage, lastPage } = this.pagination;

      if (lastPage <= 7) {
        for (let i = 1; i <= lastPage; i++) {
          pages.push(i);
        }
      } else {
        if (currentPage <= 4) {
          for (let i = 1; i <= 5; i++) {
            pages.push(i);
          }
          pages.push("...");
          pages.push(lastPage);
        } else if (currentPage >= lastPage - 3) {
          pages.push(1);
          pages.push("...");
          for (let i = lastPage - 4; i <= lastPage; i++) {
            pages.push(i);
          }
        } else {
          pages.push(1);
          pages.push("...");
          for (let i = currentPage - 1; i <= currentPage + 1; i++) {
            pages.push(i);
          }
          pages.push("...");
          pages.push(lastPage);
        }
      }

      return pages;
    },
  },
  methods: {
    getKey(page, index) {
      return page === "..." ? `ellipsis-${index}` : page;
    },
    goToPage(page) {
      if (page !== "..." && page > 0 && page <= this.pagination.lastPage) {
        this.$emit("goto-page", page);
      }
    },
  },
};
</script>
<style scoped>
/* PAGINATION */
.pagination li a {
  padding: 5px 8px !important;
  font-size: 12px !important;
  background-color: var(--bg-color-two);
  margin: 0 1.5px !important;
  text-align: center;
  cursor: pointer;
  border: 0.5px solid var(--border-one);
  border-radius: 3px;
  color: var(--text-one);
}
.pagination li:hover {
  background-color: var(--hover-one);
}
/* PAGINATION */
</style>
